<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<app-progress></app-progress>
<div class="p-8 table-list mat-typography">
    <mat-card>
    <mat-card-header>
      <mat-card-title>
          <div class="flex items-center justify-between w-full">
        <span>{{dataSource && dataSource.data ? (dataSource.data.length | i18nPlural: itemPluralMapping) : '0 Items'}}</span>
        <span style="margin-left: 10px;"><button (click)="downloadCsv()" mat-raised-button color="primary">Export CSV</button></span>
          </div>
      </mat-card-title>
      <mat-card-subtitle>
        <mat-form-field>
          <input (keyup)="search($event)" matInput placeholder="Search">
        </mat-form-field>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="w-full">
      <table [dataSource]="dataSource" mat-table matSort [matSortDisableClear]="true">

        <!-- Customer Part Number Column -->
        <ng-container matColumnDef="customerPartNumber">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Customer Part No.</th>
          <td *matCellDef="let element" mat-cell><a [routerLink]="['/item/', element.id]">{{element.customerPartNumber}}</a></td>
        </ng-container>

        <!-- Location Column -->
        <ng-container matColumnDef="location">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Location</th>
          <td *matCellDef="let element" mat-cell>
            @if (element.locationName) {
              <span>{{element.locationName}}</span>
            }
            @if (!element.locationName && !element.location) {
              <span>Jobsite</span>
            }
          </td>
        </ng-container>

        <!-- Unique ID Column -->
        <ng-container matColumnDef="uniqueItemId">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Unique Item ID</th>
          <td *matCellDef="let element" mat-cell><a [routerLink]="['/item/', element.id]">{{element.uniqueItemId}}</a></td>
        </ng-container>

        <!-- Item Type Column -->
        <ng-container matColumnDef="itemType">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Item Type</th>
          <td *matCellDef="let element" mat-cell>{{element.itemType}}</td>
        </ng-container>

        <!-- Eclipse ID Column -->
        <ng-container matColumnDef="eclipseId">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Eclipse ID</th>
          <td *matCellDef="let element"
            mat-cell><a [routerLink]="['/item/', element.id]">{{element.eclipseId}}</a></td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef class="column-less" mat-header-cell>Actions</th>
            <td *matCellDef="let row" mat-cell>
                <div class="flex items-center gap-2">
              <button (click)="deleteItem(row)" class="mat-elevation-z0" color="primary" mat-mini-fab><i
              class="material-icons">delete</i></button>
                </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.item-light-red]="row.flag === 1" [class.item-light-yellow]="row.flag === 2">
          </table>
          <mat-paginator [pageSizeOptions]="[15, 50, 100]" [showFirstLastButtons]="true"></mat-paginator>
        </mat-card-content>
      </mat-card>
    </div>
